import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { CountryData } from 'ng2-app/models/dto/country-data.model';

@Injectable({
  providedIn: 'root'
})
export class CountryDataService {

  baseUrl = environment.API_URL;

  constructor(private http: ApiHttpClient) {
    this.baseUrl = environment.API_URL;
  }

  getCountryData(): Observable<CountryData[]> {
    return this.http.get<CountryData[]>(`${this.baseUrl}/country-data`);
  }
}
